module.exports = __webpack_public_path__ + "img/thoma.38c4815b.webp";